module.exports = {
          srcSet: __webpack_public_path__ + "654bbcf1.jpg"+" 700w"+","+__webpack_public_path__ + "28ef2f15.jpg"+" 1400w"+","+__webpack_public_path__ + "6c5f9e82.jpg"+" 2100w"+","+__webpack_public_path__ + "f9c61c1e.jpg"+" 2681w",
          images:[ {path: __webpack_public_path__ + "654bbcf1.jpg",width: 700,height: 453},{path: __webpack_public_path__ + "28ef2f15.jpg",width: 1400,height: 907},{path: __webpack_public_path__ + "6c5f9e82.jpg",width: 2100,height: 1361},{path: __webpack_public_path__ + "f9c61c1e.jpg",width: 2681,height: 1737}],
          src: __webpack_public_path__ + "654bbcf1.jpg",
          toString:function(){return __webpack_public_path__ + "654bbcf1.jpg"},
          
          width: 700,
          height: 453
        }